import {
  USER_CREATE,
  USER_LIST,
  USER_UPDATE,
  USER_FILTER,
  USER_CREATE_SUCCESS,
  USER_LIST_SUCCESS,
  USER_UPDATE_SUCCESS,
  USER_REQUEST_FAILED,
} from "store/users/actionTypes";

const initialState = {
  users: [],
  userCreated: {},
  userUpdated: {},
  loading: false,
  error: "",
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case USER_CREATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case USER_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case USER_UPDATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case USER_FILTER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case USER_CREATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        userCreated: action.payload,
        error: "",
      };
      break;
    case USER_LIST_SUCCESS:
      state = {
        ...state,
        loading: false,
        users: action.payload,
        userCreated: {},
        userUpdated: {},
        error: "",
      };
      break;
    case USER_UPDATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        userUpdated: action.payload,
        error: "",
      };
      break;
    case USER_REQUEST_FAILED:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default user;
